<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb :title="page.title" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>

         <v-row dense justify="center">
            <v-col cols="12" md="8">
               <v-card>
                  <v-toolbar dark color="primary">
                     <v-icon left>mdi-school-outline</v-icon>
                     <v-toolbar-title>Graduate Upgrade Endorsement</v-toolbar-title>
                  </v-toolbar>

                  <v-card-text>
                     <v-alert type="info" dense text>
                        You have been selected as a <strong>{{ roleLabel }}</strong> for the following Graduate Upgrade application.
                        Please review the details and approve or reject.
                     </v-alert>

                     <v-card outlined class="mb-4">
                        <v-card-text>
                           <div class="overline blue--text">Applicant Details</div>
                           <div class="text-h6 font-weight-bold">{{ memberinfo.fullname }}</div>
                           <div class="body-2 grey--text">{{ memberinfo.contactemail }}</div>
                           <div class="body-2 mt-1">MIP Member ID: <strong>{{ memberinfo.memberid || 'Not assigned' }}</strong></div>
                           <div class="body-2 mt-1">Member Type: <strong>Student (STU)</strong></div>
                           <div v-if="certificateUrl" class="mt-3">
                              <a :href="certificateUrl" target="_blank">
                                 <v-btn small outlined color="primary">
                                    <v-icon left small>mdi-file-document-outline</v-icon>
                                    View Degree Certificate
                                 </v-btn>
                              </a>
                           </div>
                        </v-card-text>
                     </v-card>

                     <v-alert v-if="flash.status" type="success" dense text>{{ flash.status }}</v-alert>
                     <v-alert v-if="flash.error" type="error" dense text>{{ flash.error }}</v-alert>
                  </v-card-text>

                  <v-card-actions class="px-4 pb-4">
                     <v-spacer></v-spacer>
                     <v-btn text href="/dashboard">Back to Dashboard</v-btn>
                     <v-btn
                        color="error"
                        outlined
                        :loading="rejecting"
                        :disabled="submitting"
                        @click="reject"
                     >
                        <v-icon left>mdi-close</v-icon>Reject
                     </v-btn>
                     <v-btn
                        color="success"
                        dark
                        :loading="approving"
                        :disabled="submitting"
                        @click="approve"
                     >
                        <v-icon left>mdi-check</v-icon>Approve
                     </v-btn>
                  </v-card-actions>
               </v-card>
            </v-col>
         </v-row>
      </v-container>
   </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'

export default {
   name: 'MOMGraduateEndorsement',
   components: { DashboardLayout, BaseBreadcrumb },
   props: {
      memberinfo: { type: Object, required: true },
      role: { type: String, required: true },
      applicant_userid: { type: Number, required: true },
   },
   data() {
      return {
         page: { title: 'Graduate Endorsement' },
         breadcrumbs: [
            { text: 'Dashboard', disabled: false, to: '/dashboard' },
            { text: 'Graduate Endorsement', disabled: true },
         ],
         approving: false,
         rejecting: false,
      }
   },
   computed: {
      submitting() { return this.approving || this.rejecting },
      roleLabel() { return this.role === 'proposer' ? 'Proposer' : 'Seconder' },
      certificateUrl() {
         if (!this.memberinfo.applgrad_certificate || !this.memberinfo.applgrad_certificatepath) return null
         return '/' + this.memberinfo.applgrad_certificatepath + '/' + this.memberinfo.applgrad_certificate
      },
      flash() {
         return (this.$page && (this.$page.props || this.$page).flash) || {}
      },
   },
   methods: {
      approve() {
         if (!window.confirm(`Confirm APPROVE?`)) return
         this.approving = true
         this.$inertia.get(`/member/graduate-upgrade/${this.role}/approve/${this.applicant_userid}`, {}, {
            onFinish: () => { this.approving = false }
         })
      },
      reject() {
         if (!window.confirm(`Confirm REJECT?'`)) return
         this.rejecting = true
         this.$inertia.get(`/member/graduate-upgrade/${this.role}/reject/${this.applicant_userid}`, {}, {
            onFinish: () => { this.rejecting = false }
         })
      },
   },
}
</script>